import { render, staticRenderFns } from "./AboutUs_box3_inner.vue?vue&type=template&id=d34521fa"
import script from "./AboutUs_box3_inner.vue?vue&type=script&lang=js"
export * from "./AboutUs_box3_inner.vue?vue&type=script&lang=js"
import style0 from "./AboutUs_box3_inner.vue?vue&type=style&index=0&id=d34521fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports